import React, { Fragment } from "react";
import { orderBy } from "lodash";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import StyledTableCell from "../tabel-component/StyledTableCell";

export default function VerticalSignificanceAcceptTable({ data }) {
  return (
    <Fragment>
      <Toolbar>
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          Accepted
        </Typography>
      </Toolbar>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">UID</StyledTableCell>
            <StyledTableCell align="center">OBJECT NAME</StyledTableCell>
            <StyledTableCell align="center">LATITUDE</StyledTableCell>
            <StyledTableCell align="center">LONGITUDE</StyledTableCell>
            <StyledTableCell align="center">
              TOP ELEV. IN m. (EGM 08)
            </StyledTableCell>
            <StyledTableCell align="center">
              DISTANCE IN M. FROM NEW ARP
            </StyledTableCell>
            <StyledTableCell align="center">
              MAG. BRG.FROM NEW ARP
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orderBy(data, ["uid1"], ["asc"]).map((row, i) => {
            return (
              <TableRow key={i}>
                <StyledTableCell align="center">{row["uid1"]}</StyledTableCell>
                <StyledTableCell align="center">
                  {row["object1"]}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row["latitude1"]}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row["longitude1"]}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row["top_elev1"]}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row["distance1"]}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row["mag_brg1"]}
                </StyledTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Fragment>
  );
}
